export default {
    allDaily: [],
    showDaily: {},
    dailyDeleteId: '',
    pagination: {},
    searchQuery: "",
    }